import { Offset, DOMRect, Viewport } from '../rocket';

export class DOMScroll {
  public static get scrollLeft(): number {
    if (typeof window.pageXOffset === 'number') {
      return window.pageXOffset;
    }

    return document.documentElement.scrollLeft || document.body.scrollLeft || window.scrollX || 0;
  }

  public static get scrollTop(): number {
    if (typeof window.pageYOffset === 'number') {
      return window.pageYOffset;
    }

    return document.documentElement.scrollTop || document.body.scrollTop || window.scrollY || 0;
  }

  public static getScrollLeftToElements(elements: HTMLElement | HTMLElement[]): number {
    let rect;
    let left = 0;

    if (Array.isArray(elements) === true) {
      rect = DOMRect.getRectFromElements(elements);
    } else {
      rect = (elements as HTMLElement).getBoundingClientRect();
    }

    if (rect !== false) {
      left = rect.left;
    }

    return left + this.scrollLeft;
  }

  public static getScrollTopToElements(elements: HTMLElement | HTMLElement[]): number {
    let rect;
    let top = 0;

    if (Array.isArray(elements) === true) {
      rect = DOMRect.getRectFromElements(elements);
    } else {
      rect = (elements as HTMLElement).getBoundingClientRect();
    }

    if (rect !== false) {
      top = rect.top;
    }

    return top + this.scrollTop;
  }

  public static getScrollLeftToElementsCenterFrame(elements: HTMLElement | HTMLElement[]): number {
    let rect;
    let left = 0;
    let width = 0;

    if (Array.isArray(elements) === true) {
      rect = DOMRect.getRectFromElements(elements);
    } else {
      rect = (elements as HTMLElement).getBoundingClientRect();
    }

    if (rect !== false) {
      left = rect.left;
      width = rect.width;
    }

    return left - (Viewport.width - width) / 2 + this.scrollLeft;
  }

  public static getScrollTopToElementsCenterFrame(elements: HTMLElement | HTMLElement[]): number {
    let rect;
    let top = 0;
    let height = 0;

    if (Array.isArray(elements) === true) {
      rect = DOMRect.getRectFromElements(elements);
    } else {
      rect = (elements as HTMLElement).getBoundingClientRect();
    }

    if (rect !== false) {
      top = rect.top;
      height = rect.height;
    }

    return top - (Viewport.height - height) / 2 + this.scrollTop;
  }

  public static getScrollToElementsCenterFrame(elements: HTMLElement): Offset {
    return {
      left: this.getScrollLeftToElementsCenterFrame(elements),
      top: this.getScrollTopToElementsCenterFrame(elements),
    };
  }
}
